/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobHeapAnalysisModule {
    getFixupPrototypeFunction() { return BackgroundJobHeapAnalysisModule.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobHeapAnalysisModule>): BackgroundJobHeapAnalysisModule {
        let obj = Object.assign(new BackgroundJobHeapAnalysisModule(), model);
        BackgroundJobHeapAnalysisModule.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobHeapAnalysisModule>): BackgroundJobHeapAnalysisModule {
        if (!model) return null;
        return BackgroundJobHeapAnalysisModule.newInstance(<BackgroundJobHeapAnalysisModule> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobHeapAnalysisModule) {
        if (!obj) return;

        models.BackgroundJobHeapAnalysisModule.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobHeapAnalysisModule): boolean {
        Object.setPrototypeOf(obj, BackgroundJobHeapAnalysisModule.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.size === undefined) {
            this.size = 0;
        }
        if (this.count === undefined) {
            this.count = 0;
        }
    }

    /**
     * Module name
     */
    name: string;

    /**
     * Bytes used in module
     */
    size: number;

    /**
     * Object counted in module
     */
    count: number;

}
